import { defineStore } from 'pinia'
import { ref } from 'vue'
import { ViewModes } from 'Modules/types/pages/imageReview/enums'
import type { Ref } from 'vue'

export const useInterfaceStore = defineStore('ImageReview_interface', () => {
  //State
  const isDefectDetailsVisible = ref(false)
  const viewMode: Ref<ViewModes> = ref(ViewModes.Annotator)

  //Actions
  function cycleViewMode() {
    const viewModeKeys: Array<ViewModes> = Object.keys(ViewModes) as Array<ViewModes>
    const getNextIndex = (): number => {
      const currValIndex = viewModeKeys.indexOf(viewMode.value)
      if (currValIndex + 1 === viewModeKeys.length) {
        return 0
      }
      return viewModeKeys.indexOf(viewMode.value) + 1
    }
    const nextIndex = getNextIndex()

    viewMode.value = ViewModes[viewModeKeys[nextIndex]]
  }

  function setViewMode(mode: ViewModes) {
    viewMode.value = mode
  }

  return {
    isDefectDetailsVisible,
    viewMode,
    cycleViewMode,
    setViewMode,
  }
})
